import AvailabilityService from '../api/availability-service'

export default {
    namespaced: true,
    state: {
        pending: null,
        products: [],
        selectedProductId: null,
        requirements: [{
            id: 'primary',
            quantity: 0
        },
        {
            id: 'secondary',
            quantity: 0
        }
        ],
        productsAsExtras: false,
        promoApplied: false,
        lastQuery: null
    },
    mutations: {
        setProducts (state, products) {
            state.products = products
        },
        setProductsAsExtras (state, products) {
            state.products = products.map(e => {
                e = {
                    ...e,
                    totalPrice: 0
                }
                e.offerLines = e.offerLines.map(o => ({
                    ...o,
                    quantity: 0,
                    totalPrice: 0
                }))
                return e
            })
            state.productsAsExtras = true
        },
        setSelectedProductId (state, productId) {
            state.selectedProductId = productId
            if (state.productsAsExtras) {
                const product = state.products.find(p => p.id === productId)
                if (product !== undefined) {
                    for (let i = 0; i < product.offerLines.length; i++) {
                        product.offerLines[i].quantity = state.requirements[i].quantity
                        product.offerLines[i].totalPrice = product.offerLines[i].totalPricePerUnit * product.offerLines[i].quantity
                    }
                    product.totalPrice = product.offerLines.reduce((accumulator, o) => {
                        return accumulator + o.totalPrice
                    }, 0)
                }
            }
        },
        resetSelectedProductId (state) {
            state.selectedProductId = null
        },
        reset (state) {
            state.pending = null
            state.products = []
            state.selectedProductId = null
            state.productsAsExtras = false
            state.promoApplied = false
            state.lastQuery = null
        },
        resetRequirements (state) {
            state.requirements = [{
                id: 'primary',
                quantity: 0
            },
            {
                id: 'secondary',
                quantity: 0
            }
            ]
        },
        setRequirement (state, requirement) {
            const existingRequirement = state.requirements.find(r => r.id === requirement.id)
            if (existingRequirement !== undefined) {
                existingRequirement.quantity = requirement.quantity
            } else {
                state.requirements.push(requirement)
            }
        },
        setPending (state, isPending) {
            state.pending = isPending
        },
        setPromoApplied (state, promoApplied) {
            state.promoApplied = promoApplied
        },
        preserveQuery (state, query) {
            const {
                promoCode,
                ...preserve
            } = query
            state.lastQuery = preserve
        }
    },
    actions: {
        async getParkingAvailability (context, query) {
            context.commit('setPending', true)
            const response = await AvailabilityService.getParkingAvailability(query)
            context.commit('setProducts', response.data.parkingAvailabilities)
            context.commit('setPromoApplied', response.data.promotionApplied)
            context.commit('preserveQuery', query)
            context.commit('setPending', false)
        },
        async getLoungeAvailability (context, query) {
            context.commit('setPending', true)
            const response = await AvailabilityService.getLoungeAvailability(query)
            context.commit('setProductsAsExtras', response.data.extraAvailabilities)
            context.commit('setPromoApplied', response.data.promotionApplied)
            context.commit('setSelectedProductId', context.state.selectedProductId)
            context.commit('preserveQuery', query)
            context.commit('setPending', false)
        },
        async getFastTrackAvailability (context, query) {
            context.commit('setPending', true)
            const response = await AvailabilityService.getFastTrackAvailability(query)
            context.commit('setProductsAsExtras', response.data.extraAvailabilities)
            context.commit('setPromoApplied', response.data.promotionApplied)
            context.commit('preserveQuery', query)
            context.commit('setPending', false)
        },
        async setSelectedProductId (context, productId) {
            await context.commit('setSelectedProductId', productId)
        },
        async resetSelectedProductId (context) {
            await context.commit('resetSelectedProductId')
        }
    },
    getters: {
        getRequirement: state => requirementId => {
            return state.requirements.find(r => r.id === requirementId)
        },
        getSelectedProduct: state => productId => {
            return state.products.find(p => p.id === productId)
        },
        getProductsWithAvailableQuantity (state, getters) {
            var requirementsQuantity = 0
            state.requirements.forEach((requirement) => {
                requirementsQuantity += requirement.quantity
            })
            if (state.products) {
                return state.products.filter((product) => {
                    return product.maxQuantity >= requirementsQuantity
                })
            }
            return []
        },
        requirementsExceedSomeProductQuantities (state, getters) {
            if (state.products) {
                return (state.products.length !== getters.getProductsWithAvailableQuantity.length)
            }
            return []
        }
    }
}
